import { useState } from 'react';
import errorCodes from '../../../../docs/error-codes-reference.json';

interface ErrorEntry {
  code: string;
  domain: string;
  http_status: number;
  message_en: string;
  description_zh: string;
}

const YAPI_KEY = 'pt.console.yapi';

export function ContractPage() {
  const entries = (errorCodes as { errors: ErrorEntry[]; count: number }).errors;
  const [filter, setFilter] = useState('');
  const [yapi, setYapi] = useState(localStorage.getItem(YAPI_KEY) ?? '');
  const shown = entries.filter((e) => `${e.code} ${e.message_en} ${e.description_zh}`.toLowerCase().includes(filter.toLowerCase()));

  return (
    <div className="space-y-6">
      <section className="card">
        <h2 className="mb-2 font-semibold">契约来源</h2>
        <ul className="list-disc space-y-1 pl-5 text-sm text-zinc-300">
          <li><code>docs/openapi.yaml</code> — 由各 worker 的 zod-openapi 路由声明聚合（<code>pnpm openapi:build</code>），preflight 防漂移</li>
          <li><code>docs/error-codes-reference.json</code> — 由 <code>ErrorCodes</code> 生成（{entries.length} 个错误码）</li>
          <li><code>@pockettavern/st-schemas</code> — SillyTavern 实体 zod schema / TS 类型（<code>pnpm --filter @pockettavern/st-schemas pack</code>）</li>
        </ul>
        <div className="mt-4">
          <label className="label">YApi 实例地址（本地保存，用于快速跳转）</label>
          <div className="flex gap-2">
            <input className="input" value={yapi} onChange={(e) => setYapi(e.target.value)} onBlur={() => localStorage.setItem(YAPI_KEY, yapi)} placeholder="http://yapi.example.com" />
            {yapi && <a className="btn-ghost whitespace-nowrap" href={yapi} target="_blank" rel="noreferrer">打开 YApi</a>}
          </div>
          <p className="mt-1 text-xs text-zinc-500">三个项目：客户端（/api/*）· 管理后台（/api/admin/*, /api/ops/*）· 内部（/internal/*）。同步命令 <code>pnpm yapi:sync</code>。</p>
        </div>
      </section>

      <section className="card">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="font-semibold">错误码 <span className="text-xs text-zinc-400">{shown.length}/{entries.length}</span></h2>
          <input className="input w-64 py-1" placeholder="筛选…" value={filter} onChange={(e) => setFilter(e.target.value)} />
        </div>
        <div className="overflow-auto">
          <table className="w-full text-left text-sm">
            <thead className="text-xs uppercase text-zinc-400">
              <tr><th className="py-2 pr-3">code</th><th className="py-2 pr-3">status</th><th className="py-2 pr-3">message</th><th className="py-2">说明</th></tr>
            </thead>
            <tbody>
              {shown.map((e) => (
                <tr key={e.code} className="border-t border-zinc-800">
                  <td className="py-2 pr-3 font-mono text-xs text-indigo-300">{e.code}</td>
                  <td className="py-2 pr-3 font-mono text-xs">{e.http_status}</td>
                  <td className="py-2 pr-3 text-zinc-300">{e.message_en}</td>
                  <td className="py-2 text-zinc-400">{e.description_zh}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
